export enum BUTTON_SIZE {
  LARGE = 'large',
  NORMAL = 'normal',
  SMALL = 'small',
}

export enum BUTTON_COLOR {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  LINK = 'link',

  RED = 'red', // OK
  GREEN = 'green', // OK
  DARK_GREEN = 'darkGreen',
  // LEGACY
  COLOR = 'color', // primary
  LIGHT_COLOR = 'lightColor', // secondary
  GREY = 'grey',
  WHITE = 'white', // tertiary ?
  LIGHT_GREY = 'lightGrey', // tertiary

  BLACK = 'black', // disabled + primary ?
  DOUBLE_GREY = 'doubleGrey', // secondary ?
  LIGHT_DOUBLE_GREY = 'lightDoubleGrey', // secondary ?
}

export enum BUTTON_WEIGHT {
  OUTLINED = 'outlined',
  FILLED = 'filled',
}
